import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";

class AutoclickBehaviorLoadDelay extends AutoclickBehaviorAbstract {
  onHtmlLoaded() {
    this.delayClickthrough(this.getBehaviorDelay());
  }
}

export default AutoclickBehaviorLoadDelay;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorLoadDelay.js